import { NodeTypeCodes } from '@kcftech/prometheus-client';
import {
    EnvelopedDetails,
    EnvelopedLabel,
    EnvelopedRow,
    EnvelopedValue,
} from 'components/node_settings/V4EditSettingsModal/AdvancedSettingsTab/styled';
import { ToggleSetting } from 'components/node_settings/V4Settings/ToggleSetting';
import { getDisabledSamplingFrequencyOptions } from 'components/node_settings/V4EditSettingsModal/CollectionSettingsTab/collectionDurationValidation';
import { DisabledHint } from 'components/node_settings/V4EditSettingsModal/styled';
import { V4_SETTINGS_TEXT } from 'components/node_settings/v4SettingsTexts';
import { NumericOptionDropdown } from 'components/dropdown/NumericOptionDropdown';
import { useSamplingFrequencyOptions } from 'custom_hooks/data_hooks/nodes/useSamplingFrequencyOptions';
import {
    DEFAULT_ENVELOPED,
    V4SensorSettings,
} from 'custom_hooks/data_hooks/v4_sensor_settings/shared';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

export function EnvelopedDataSetting() {
    const { control, setValue } = useFormContext<V4SensorSettings>();
    const envelopedData = useWatch({ control, name: 'envelopedData' });
    const vibrationY = useWatch({ control, name: 'vibrationY' });
    const updateInterval = useWatch({ control, name: 'updateInterval' });

    const { validOptions: samplingFrequencyOptions } = useSamplingFrequencyOptions(
        NodeTypeCodes.KcfVibrationV4,
        undefined,
    );

    const samplingFrequencyDisabledOptions = getDisabledSamplingFrequencyOptions(
        samplingFrequencyOptions,
        { numberOfSamples: DEFAULT_ENVELOPED.numberOfSamples, updateInterval },
    );

    const hint = vibrationY
        ? V4_SETTINGS_TEXT.disabledHints.envelopedDisabledHint
        : V4_SETTINGS_TEXT.disabledHints.vibrationYDisabledHint;

    return (
        <>
            <ToggleSetting
                name={V4_SETTINGS_TEXT.settingNames.envelopedData}
                ariaLabel={V4_SETTINGS_TEXT.settingNames.envelopedData}
                helperText={V4_SETTINGS_TEXT.descriptions.envelopedDataHelper}
                checked={envelopedData.enabled}
                disabled={!vibrationY}
                onChange={(checked) =>
                    setValue(
                        'envelopedData',
                        checked ? DEFAULT_ENVELOPED : { enabled: false },
                        { shouldDirty: true, shouldValidate: true },
                    )
                }
            />
            <EnvelopedDetails>
                <EnvelopedRow>
                    <EnvelopedLabel>
                        {V4_SETTINGS_TEXT.settingNames.samplingFrequency}
                    </EnvelopedLabel>
                    {envelopedData.enabled ? (
                        <EnvelopedValue>
                            <Controller
                                control={control}
                                name="envelopedData.samplingFrequencyHz"
                                render={({ field }) => (
                                    <NumericOptionDropdown
                                        value={field.value}
                                        options={samplingFrequencyOptions}
                                        onChange={field.onChange}
                                        disabledOptions={samplingFrequencyDisabledOptions}
                                    />
                                )}
                            />
                        </EnvelopedValue>
                    ) : (
                        <DisabledHint>{hint}</DisabledHint>
                    )}
                </EnvelopedRow>
                <EnvelopedRow>
                    <EnvelopedLabel>
                        {V4_SETTINGS_TEXT.settingNames.numberOfSamples}
                    </EnvelopedLabel>
                    {envelopedData.enabled ? (
                        <EnvelopedValue>
                            {envelopedData.numberOfSamples} Samples
                        </EnvelopedValue>
                    ) : (
                        <DisabledHint>{hint}</DisabledHint>
                    )}
                </EnvelopedRow>
            </EnvelopedDetails>
        </>
    );
}
